import { Reducer } from 'react';
import { AppConfigDto } from '../../models/AppConfigModel';
import { ConfigurationActionTypes, ReducerAction } from './actions';
import { ConfigurationState } from './ConfigurationContext';

export const reducer: Reducer<ConfigurationState, ReducerAction> = (state, action) => {
    switch (action.type) {
        case ConfigurationActionTypes.SetHeaderOffsetHeight: {
            return {
                ...state,
                headerOffsetHeight: action.payload as number
            };
        }

        case ConfigurationActionTypes.SetConfiguration: {
            return {
                ...state,
                appConfigs: action.payload as AppConfigDto[]
            };
        }

        case ConfigurationActionTypes.SetResDragModalZIndex: {
            return {
                ...state,
                resDragModalZIndex: action.payload as number
            };
        }

        default:
            return state;
    }
};
